export default __webpack_public_path__ + "static/media/14-SAP-Logo.9a66108a.jpg";